/* eslint-disable no-loop-func */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingWidget } from "../../../../components/widgets/loading";
import { StoreState } from "../../../../types/models/store";
import "../../../../assets/scss/components/cards.scss";
import "../../../../assets/scss/components/track/trackTable.scss";

const TrackOverlayTable: React.FC<any> = (props) => {
  const { trackSearch = {} } = props.data;
  const { idsexist, selectedItems, setSelectedItems } = props;
  const { select_tracks } = useSelector(
    (state: StoreState) => state.selectTrack
  );
  const dispatch = useDispatch();

  const handleCheckboxChange = (id: number) => {
    const list = trackSearch.list;
    const selectedItem = list.find((item: any) => item.id === id);

    if (selectedItem) {
      const updatedSelectedItems = [...select_tracks];
      if (!select_tracks.some((track) => track.id === id)) {
        selectedItem.checked = true;
        updatedSelectedItems.push({ idsexist, id });
      } else {
        selectedItem.checked = false;
        const index = updatedSelectedItems.findIndex(
          (track) => track.id === id
        );
        if (index !== -1) {
          updatedSelectedItems.splice(index, 1);
        }
      }
      dispatch({
        type: "SET_SELECT_TRACKS",
        payload: updatedSelectedItems,
      });
      setSelectedItems(updatedSelectedItems);
    }
  };

  const handleSelectAll = () => {
    const list = trackSearch.list;
    const isAllSelected = list.every((item: any) => item.checked);

    list.forEach((item: any) => {
      if (!isAllSelected) {
        item.checked = true;
      } else {
        item.checked = false;
      }
    });

    const updatedSelectedItems = isAllSelected
      ? []
      : list.map((item: any) => ({ idsexist: idsexist, id: item.id }));

    dispatch({
      type: "SET_SELECT_TRACKS",
      payload: updatedSelectedItems,
    });
    setSelectedItems(updatedSelectedItems);
  };

  useEffect(() => {
    setSelectedItems(select_tracks);
  }, [select_tracks]);

  return (
    <>
      <div className="track-table table-card">
        <table className="table-view w-100">
          <thead>
            <tr>
              <th>
                <span className="focus" onClick={handleSelectAll}>
                  <img
                    className="chk"
                    src={`/imgs/checkbox-${
                      trackSearch.checked ? "" : "un"
                    }checked-all.svg`}
                    alt=""
                  />
                </span>
              </th>
              <th>
                <span>Track Title</span>
              </th>
              <th>
                <span>Album</span>
              </th>
              <th>
                <span>Artists</span>
              </th>
              <th>
                <span>Composer</span>
              </th>
              <th>
                <span>Time</span>
              </th>
              <th>
                <span>Genre</span>
              </th>
              <th>
                <span>ISRC</span>
              </th>
              <th>
                <span>Source</span>
              </th>
              <th>
                <span>Source CD</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {trackSearch.isLoaded ? (
              <tr>
                <td colSpan={10}>
                  <LoadingWidget />
                </td>
              </tr>
            ) : (
              <>
                {trackSearch.list?.map((item: any, index: number) => (
                  <tr key={index}>
                    {/* check box */}
                    <td style={{ width: "64px" }}>
                      <div
                        className="cell-content focus tw-flex tw-justify-center"
                        onClick={() => {
                          handleCheckboxChange(item.id);
                        }}
                      >
                        <img
                          className="check"
                          src={`/imgs/checkbox-${
                            selectedItems.some(
                              (track: any) => track.id === item.id
                            )
                              ? ""
                              : "un"
                          }checked.svg`}
                          width={"20px"}
                          height={"20px"}
                          alt=""
                        />
                      </div>
                    </td>

                    {/* Track title */}
                    <td style={{ minWidth: "200px" }}>
                      <div className="cell-content">{item.track_title}</div>
                    </td>

                    {/* Album */}
                    <td style={{ minWidth: "200px" }}>
                      <div className="cell-content flex tw-gap-[5px]">
                        <span>{item.album_title}</span>
                      </div>
                    </td>

                    {/* artist */}
                    <td style={{ minWidth: "150px" }}>
                      <div className="cell-content">{item?.primart_title}</div>
                    </td>

                    {/* Composer */}
                    <td style={{ minWidth: "100px" }}>
                      {" "}
                      <div className="cell-content">{item?.composer}</div>
                    </td>

                    {/* Time */}
                    <td style={{ width: "100px", whiteSpace: "nowrap" }}>
                      <div className="cell-content">{item?.release_date}</div>
                    </td>

                    {/* Genres */}
                    <td style={{ minWidth: "180px" }}>{item.genre_title}</td>

                    {/* ISRC */}
                    <td style={{ minWidth: "90px" }}>
                      <div className="cell-content">{item.isrc}</div>
                    </td>

                    {/* Source */}
                    <td style={{ minWidth: "170px" }}>
                      <div className="cell-content">{item.source}</div>
                    </td>

                    {/* Source CD */}
                    <td style={{ minWidth: "170px" }}>
                      <div className="cell-content">{item.source_cd}</div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TrackOverlayTable;
